<div class="app-card" *ngIf="this.trans">
  <h1 class="card-header title-blue font-roboto-condensed font-23 font-normal">{{ this.trans.informacionGeneral }}</h1>
  <div class="card-body">
    <div class="p-fluid">
      <div class="p-field">
        <h2 class="label-form-sidebar subtitle">{{ this.trans.razonSocial }}</h2>
        <p *ngIf="isLoading; else razonSocial" class="details-text">
          <p-skeleton width="10rem"></p-skeleton>
        </p>
        <ng-template #razonSocial>
          <p class="details-text">{{ informacion.nombreCompleto }}</p>
        </ng-template>
      </div>
      <div class="grid">
        <div class="col-12 md:col-6">
          <div class="p-field">
            <h2 class="label-form-sidebar subtitle">{{ this.trans.tipoIdentificacion }}</h2>
            <p *ngIf="isLoading; else tipoIdentificacion" class="details-text">
              <p-skeleton width="8rem"></p-skeleton>
            </p>
            <ng-template #tipoIdentificacion>
              <p class="details-text">{{ informacion.tipoIdentificacion }}</p>
            </ng-template>
          </div>
        </div>
        <div class="col-12 md:col-6">
          <div class="p-field">
            <h2 class="label-form-sidebar subtitle">{{ this.trans.identificacion }}</h2>
            <p *ngIf="isLoading; else identificacion" class="details-text">
              <p-skeleton width="12rem"></p-skeleton>
            </p>
            <ng-template #identificacion>
              <p class="details-text">{{ informacion.identificacion }}</p>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
